import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=16c9ac3e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c9ac3e')) {
      api.createRecord('16c9ac3e', component.options)
    } else {
      api.reload('16c9ac3e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=16c9ac3e&", function () {
      api.rerender('16c9ac3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29qOre4QYjwDy/JS/videoIframe.vue"
export default component.exports